module.exports = __webpack_public_path__ + "fonts/nunito-variable-latin.00a333a.woff2";